import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../core/services/config/config.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { PatientImmunizationGroup } from '../models/patient-immunization-group';

@Injectable({
  providedIn: 'root',
})
export class PatientImmunizationsService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  patientImmunizationsEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientImmunizations`;

  getPatientImmunizations(patientId: number): Observable<PatientImmunizationGroup[]> {
    const url = `${this.patientImmunizationsEndpoint}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientImmunizationGroup[]>(url);
  }

  postPrintEvent(patientId: number, ids: number[]): Observable<void> {
    const url = `${this.patientImmunizationsEndpoint}/PrintEvent?patientId=${patientId}`;
    return this.utilityService.postRequest<void>(url, { ids }, { skipGlobalError: true });
  }
}
